import React, { useState, useEffect } from 'react';
import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';
import DepartmentTab from '../mainTags/CSEDepartmentTab';

const CSEIndustrySupportedLab = () => {





    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <DepartmentTab />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Industry Supported Labs in CSE Department
                                </h2>
                               <div className='pt-2 submit'>
                                    <div className='eventsImages'>
                                        <div className='row mt-4'>

                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img height={"200"} src="https://admin.swec.ac.in/assetsswec/img/cse/oracle-lab.jpg" alt="Oracle Lab"
                                                     class="img-responsive rounded-1 center-block" loading="lazy" />
                                                <h6 className='pt-3'>
                                                    Oracle Lab
                                                </h6>
                                            </div>
                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img height={"200"} src="https://admin.swec.ac.in/assetsswec/img/cse/cisco-lab.jpg" alt="Cisco Lab"
                                                     class="img-responsive rounded-1 center-block" loading="lazy" />
                                                <h6 className='pt-3'>
                                                    Cisco Lab
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default CSEIndustrySupportedLab
